import { MultipleQueriesResponse, SearchOptions } from '@algolia/client-search';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environment';
import {
  ApplyInternship,
  CreateSecureSpaceInternship,
  Internship,
  InternshipOffer,
  SecureSpaceInternship,
  toSecureSpaceInternship,
  UpdateSecureSpaceInternship,
} from '@models/internships/internship';
import { AlgoliaClientService } from '@wizbii/algolia';
import { from, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class InternshipsWebService {
  constructor(private readonly algoliaClientService: AlgoliaClientService, private readonly http: HttpClient) {}

  searchInternships(query: string, searchParams?: SearchOptions): Observable<MultipleQueriesResponse<Internship>> {
    return from(
      this.algoliaClientService.client.search<Internship>([
        {
          indexName: environment.algolia.index.internship,
          query,
          params: {
            hitsPerPage: 0,
            facets: ['domain', 'location.country_short'],
            ...(searchParams?.aroundLatLng ? { aroundLatLng: searchParams?.aroundLatLng } : {}),
            ...(searchParams?.aroundRadius ? { aroundRadius: searchParams?.aroundRadius } : {}),
            filters: searchParams?.filters,
          },
        },
        {
          indexName: environment.algolia.index.internship,
          query,
          params: {
            ...searchParams,
            ...(searchParams?.aroundLatLng ? { aroundLatLng: searchParams?.aroundLatLng } : {}),
            ...(searchParams?.aroundRadius ? { aroundRadius: searchParams?.aroundRadius } : {}),
            facetFilters: searchParams?.facetFilters,
          },
        },
      ])
    );
  }

  getInternship(jobId: string): Observable<InternshipOffer> {
    return this.http.get<InternshipOffer>(`${environment.api.job_api_v2}/v1/jobs/${jobId}`);
  }

  getInternshipProviders(): Observable<Record<string, string>> {
    return this.http.get<Record<string, string>>(`${environment.api.job_importer}/v1/providers-names?destination=1j1s`);
  }

  createInternship(payload: any): Observable<any> {
    return this.http.post<any>(`${environment.api.job_api_v2}/v1/public/jobs`, payload);
  }

  applyToInternship(jobApply: ApplyInternship): Observable<unknown> {
    return this.http.post<unknown>(`${environment.api.job_api_v2}/v1/jobs/${jobApply.jobId}/candidate`, jobApply);
  }

  getPrivateInternships(id: string, token: string): Observable<SecureSpaceInternship[]> {
    return this.http
      .get<SecureSpaceInternship[]>(`${environment.api.job_api_v2}/v1/jobs/company/${id}`, {
        headers: {
          'X-AUTH-TOKEN': token,
        },
      })
      .pipe(map((results) => results.map(toSecureSpaceInternship)));
  }

  createPrivateInternship(internship: CreateSecureSpaceInternship, token: string): Observable<InternshipOffer> {
    return this.http.post<InternshipOffer>(`${environment.api.job_api_v2}/v1/public/jobs`, internship, {
      headers: {
        'X-AUTH-TOKEN': token,
      },
    });
  }

  updatePrivateInternship(internship: UpdateSecureSpaceInternship, token: string): Observable<InternshipOffer> {
    return this.http.put<InternshipOffer>(`${environment.api.job_api_v2}/v1/jobs/${internship.id}`, internship, {
      headers: {
        'X-AUTH-TOKEN': token,
      },
    });
  }
}
